define('widgets/depositValuablesList/viewmodel',['knockout'], function (ko) {

    var DepositValuableList = function(session, itemManager, getField) {
        var self = this;
        self.player = session.getAssociatedPlayer;
        self.itemManager = itemManager;
        self.valuables = ko.deferredComputed(function () {
            return self.player().depositBonus.earnedDepositBonusItems();
        });
        self.expiresText = function(item) {
            return getField('deposit_valuable_expires_in', {
                expiration: item.expirationTime.fromNow()
            });
        };
        self.activeLabel = getField('active_item_label');
        self.dontUseDepositItemLabel = getField('dont_use_valuable_label');
    };

    DepositValuableList.prototype.activate = function(settings) {
        this.onUse = settings.onUse || function() {};
    };

    DepositValuableList.prototype.useItem = function(item) {
        this.itemManager.useItem(item).then(this.onUse);
    };

    DepositValuableList.prototype.dontUseDepositItem = function() {
        var self = this,
            currentDepositItem = self.player().depositBonus.activeEarnedDepositBonusItem(),
            doAction = function() {
                self.player().depositBonus.ignoreDepositBonusItem(true);
                self.onUse();
            };

        if (currentDepositItem && currentDepositItem.canRecycle()) {
            self.itemManager.recycleItem(currentDepositItem).then(doAction);
        } else {
            doAction();
        }
    };

    return DepositValuableList;
});


